import ApiClient from '@/libs/http-client'

const LeadsService = {
    endpoints(route, param) {
        const url = {
            leads: '/api/leads',
            lead: `/api/leads/${param}`,
            leadStatus: `/api/leads/${param}/status`,
            statuses: '/api/lead-statuses',
            status: `/api/lead-statuses/${param}`,
            sources: '/api/lead-sources',
            source: `/api/lead-sources/${param}`,
        }
        return url[route]
    },
    get(url, param = '', queryParams = {}) {
        const endpoint = this.endpoints(url, param)
        return ApiClient.get(endpoint, { params: queryParams })
    },
    post(url, params = {}, data, config = {}) {
        return ApiClient.post(this.endpoints(url, params), data, config)
    },
    put(url, params = {}, data, config = {}) {
        return ApiClient.put(this.endpoints(url, params), data, config)
    },
    patch(url, params = {}, data, config = {}) {
        return ApiClient.patch(this.endpoints(url, params), data, config)
    },
    delete(url, params = {}, config = {}) {
        return ApiClient.delete(this.endpoints(url, params), config)
    },
}

export default LeadsService

